/**
 * Single source of truth for Trustpilot trust signals.
 * Update rating / reviewCount here — no UI changes required.
 */
export const TRUSTPILOT = {
  rating: 4.5,
  maxRating: 5,
  reviewCount: 17,
  /** Shown as the headline word, e.g. "Excellent" */
  ratingLabel: "Excellent",
  profileUrl: "https://www.trustpilot.com/review/recoverytrauma.com",
  supportingText:
    "Hundreds of thousands of people already follow Recovery Trauma™ across our community. Read what our members are saying about their experience with the platform.",
} as const;
